import { computed, observable, runInAction } from "mobx"

import { Model } from "@/lib/Model.ts"
import { parseTaskSettings } from "@/lib/std.ts"

import type { AiAgentTaskSettings } from "@/lib/client/generated/TypeDefinitions.ts"
import type { Queries } from "@/lib/queries.ts"

export class TaskSettingsJsonModel extends Model {
  readonly initialSettings = observable.box<AiAgentTaskSettings | null>(null)
  readonly currentJson = observable.box<string>("")
  readonly ready = observable.box<boolean>(false)

  constructor(
    private readonly taskId: string,
    private readonly queries: Queries
  ) {
    super("TaskSettingsJsonModel")
    void this.load()
  }

  private async load() {
    const task = await this.queries.task(this.taskId)
    const settings = { ...parseTaskSettings(task), className: undefined }
    runInAction(() => {
      this.initialSettings.set(settings)
      this.currentJson.set(JSON.stringify(settings, null, 2))
      this.ready.set(true)
    })
  }

  readonly hasChanges = computed(() => {
    return JSON.stringify(this.initialSettings.get()) !== this.currentJson.get()
  })

  readonly save = async (value: string) => {
    await this.queries.apiClient.updateTaskSettings(this.taskId, JSON.parse(value) as AiAgentTaskSettings)
    const task = await this.queries.task(this.taskId)
    const settings = { ...parseTaskSettings(task), calssName: undefined }
    runInAction(() => {
      this.initialSettings.set(settings)
      this.currentJson.set(JSON.stringify(settings, null, 2))
    })
  }
}

